(function () {
  function sep(s, c) { return s.replace(/\B(?=(\d{3})+(?!\d))/g, c); }
  function fmt(cents, f) {
    var a = (cents / 100).toFixed(2).split('.');
    var nd = String(Math.round(cents / 100));
    var map = {
      amount: sep(a[0], ',') + '.' + a[1],
      amount_no_decimals: sep(nd, ','),
      amount_with_comma_separator: sep(a[0], '.') + ',' + a[1],
      amount_no_decimals_with_comma_separator: sep(nd, '.'),
      amount_with_space_separator: sep(a[0], ' ') + ',' + a[1],
      amount_no_decimals_with_space_separator: sep(nd, ' '),
      amount_with_apostrophe_separator: sep(a[0], "'") + '.' + a[1]
    };
    var out = (f || '{{amount_with_comma_separator}} zł').replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) { return map[k] || map.amount_with_comma_separator; });
    var d = document.createElement('div'); d.innerHTML = out; return d.textContent;
  }

  function initGallery(g) {
    if (g.dataset.omReady) return; g.dataset.omReady = '1';
    var main = g.querySelector('[data-om-main]');
    var thumbs = g.querySelectorAll('[data-om-thumb]');
    thumbs.forEach(function (b) {
      b.addEventListener('click', function () {
        swap(main, b.getAttribute('data-om-thumb'));
        thumbs.forEach(function (x) { x.classList.toggle('is-active', x === b); });
      });
    });
  }
  function swap(main, src) {
    if (!main || !src || main.getAttribute('src') === src) return;
    main.src = src; main.classList.remove('om-zoom'); void main.offsetWidth; main.classList.add('om-zoom');
  }

  function initForm(f) {
    if (f.dataset.omReady) return; f.dataset.omReady = '1';
    var money = '{{amount_with_comma_separator}} zł';
    var mEl = f.querySelector('[data-om-money]');
    if (mEl) { try { money = JSON.parse(mEl.textContent); } catch (e) {} }
    var vs = Array.prototype.slice.call(f.querySelectorAll('[data-om-v]'));
    var bs = Array.prototype.slice.call(f.querySelectorAll('[data-om-b]'));
    var idInput = f.querySelector('[data-om-id]');
    var qtyInput = f.querySelector('[data-om-qty]');
    var total = f.querySelector('[data-om-total]');
    var submit = f.querySelector('[data-om-submit]');
    var vname = f.querySelector('[data-om-vname]');
    var section = f.closest('.om-hero');
    var main = section ? section.querySelector('[data-om-main]') : null;
    var basePrice = parseInt(f.getAttribute('data-price'), 10) || 0;
    if (vs.length && !vs.some(function (r) { return r.checked; })) vs[0].checked = true;
    if (bs.length && !bs.some(function (r) { return r.checked; })) bs[0].checked = true;

    function sync(fromVariant) {
      vs.concat(bs).forEach(function (r) {
        var l = r.closest('.om-swatch, .om-bundle'); if (l) l.classList.toggle('is-checked', r.checked);
      });
      var v = vs.filter(function (x) { return x.checked; })[0];
      var b = bs.filter(function (x) { return x.checked; })[0];
      var price = v ? parseInt(v.getAttribute('data-price-cents'), 10) : basePrice;
      var qty = b ? parseInt(b.getAttribute('data-qty'), 10) || 1 : 1;
      if (v) {
        idInput.value = v.getAttribute('data-variant');
        if (vname) vname.textContent = v.getAttribute('data-title');
        if (fromVariant) swap(main, v.getAttribute('data-img'));
        if (submit) submit.disabled = v.getAttribute('data-available') === 'false';
      }
      qtyInput.value = qty;
      f.querySelectorAll('[data-om-amount]').forEach(function (a) {
        a.textContent = fmt(price * (parseInt(a.getAttribute('data-qty'), 10) || 1), money);
      });
      if (total) total.textContent = fmt(price * qty, money);
    }
    vs.forEach(function (r) { r.addEventListener('change', function () { sync(true); }); });
    bs.forEach(function (r) { r.addEventListener('change', function () { sync(false); }); });
    sync(false);
    var status = document.createElement('p');
    status.className = 'om-cart-status';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    f.appendChild(status);
    f.addEventListener('submit', async function (event) {
      event.preventDefault();
      if (f.dataset.busy === '1' || submit.disabled) return;
      f.dataset.busy = '1';
      submit.disabled = true;
      submit.setAttribute('aria-busy', 'true');
      status.textContent = 'Dodajemy do koszyka…';
      var added = false;
      try {
        var events = await import('@shopify/events');
        var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        var body = new FormData(f);
        var ids = Array.from(document.querySelectorAll('cart-items-component[data-section-id]')).map(function (el) { return el.dataset.sectionId; });
        body.set('sections', Array.from(new Set(ids)).slice(0, 5).join(','));
        body.set('sections_url', location.pathname);
        var response = await fetch(root + 'cart/add.js', { method: 'POST', body: body, headers: { Accept: 'application/json' } });
        var result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Nie udało się dodać produktu. Spróbuj ponownie.');
        added = true;
        var cartResponse = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
        if (!cartResponse.ok) throw new Error('refresh');
        var cart = await cartResponse.json();
        f.dispatchEvent(new events.CartLinesUpdateEvent({
          action: 'add', context: 'product',
          lines: [{ merchandiseId: idInput.value, quantity: Number(qtyInput.value) }],
          promise: Promise.resolve({ cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'otulsi-form', sections: result.sections, itemCount: cart.item_count, didError: false } })
        }));
        status.textContent = 'Dodano do koszyka ✓ Możesz dalej oglądać produkty.';
      } catch (error) {
        status.textContent = added ? 'Produkt dodany. Otwórz koszyk, aby sprawdzić zamówienie.' : (error.message || 'Nie udało się dodać produktu. Spróbuj ponownie.');
      } finally {
        delete f.dataset.busy;
        submit.removeAttribute('aria-busy');
        sync(false);
      }
    });
  }

  function init(root) {
    root.querySelectorAll('[data-om-gallery]').forEach(initGallery);
    root.querySelectorAll('[data-om-form]').forEach(initForm);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
